import {
    TMaintenancePackageInitialState,
    TMaintenancePackageActionTypes,
} from './types';
import { updateMaintenancePackageState } from './utils';
import { CLEAR_STATE, SET_LOADING } from '../types';
import {
    CREATE_MAINTENANCE_PACKAGE,
    DEFAULT_MAINTENANCE_PACKAGE_STATE,
    DELETE_MAINTENANCE_PACKAGE,
    GET_MAINTENANCE_PACKAGE,
    GET_MAINTENANCE_PACKAGES,
    UPDATE_MAINTENANCE_PACKAGE,
} from './constants';

export default (
    state: TMaintenancePackageInitialState,
    action: TMaintenancePackageActionTypes
): TMaintenancePackageInitialState => {
    switch (action.type) {
        case CLEAR_STATE:
            return updateMaintenancePackageState(
                state,
                DEFAULT_MAINTENANCE_PACKAGE_STATE
            );
        case SET_LOADING:
            return updateMaintenancePackageState(state, {
                loading: true,
            });
        case GET_MAINTENANCE_PACKAGES:
            return updateMaintenancePackageState(state, {
                maintenancePackages: action.payload,
                total: action.total,
                loading: false,
            });
        case DELETE_MAINTENANCE_PACKAGE:
        case CREATE_MAINTENANCE_PACKAGE:
        case UPDATE_MAINTENANCE_PACKAGE:
        case GET_MAINTENANCE_PACKAGE:
            return updateMaintenancePackageState(state, {
                maintenancePackage: action.payload,
                loading: false,
            });
        default:
            return state;
    }
};
